<template>
  <div class="">
    <div
      v-if="!online"
      class="text-center text-xs py-1 text-white bg-stone-900"
    >
      اتصالتان به اینترنت را بررسی کنید
      <v-icon color="#fff">mdi-wifi</v-icon>
    </div>
    <component :is="layout">
      <slot />
    </component>
  </div>
</template>

<script>
import moment from "jalali-moment";
import axiosApi from "@/plugins/axios";
import "../assets/styles/main.scss";


const defaultLayout =
  localStorage.getItem("role") === "ADMIN" ? "AppLayoutAdmin" : "AppLayoutUser";

export default {
  name: "AppLayout",
  data() {
    return {
      online: navigator.onLine,
      timestamp: "",
      name: "",
      menu: [],
      factoryId: "factory",
      companyId: "company",
      notificationCount: 0,
      notification: [],
      wallet: "",
      persianDate: "",
      role: "",
      nickNameAdmin: "",
    };
  },
  methods: {
    updateOnlineStatus(e) {
      const { type } = e;
      this.online = type === "online";
    },
    getNow() {
      const today = new Date();
      const time = today.getHours() + ":" + today.getMinutes();
      const dateTime = time;
      this.timestamp = dateTime;
      const persianD = moment();
      this.persianDate = persianD.locale("fa").format("jD jMMMM jYYYY");
    },
    getRole() {
      switch (this.role) {
        case "ADMIN": {
          window.Echo.channel("admin").listen(".App\\Events\\Admin", (e) => {
            if (e.message) {
              this.notification.push({ message: e.message, route: e.route });
              this.notificationCount += 1;
              // console.log(e.route)
            }
            if (e.wallet) {
              this.wallet = e.wallet;
            }
          });
          return;
        }
        case "COMPANY": {
          axiosApi()
            .get("v2/company/dashboard")
            .then((result) => {
              this.wallet = result.data.data.wallet;
              this.companyId += result.data.data.companyId;
              this.name = result.data.data.companyName;
              localStorage.setItem("name", this.name);
            })
            .catch(e => {
              this.errors = e.response.data.errors
            });
          return;
        }
        case "FACTORY": {
          axiosApi()
            .get("v2/factory/dashboard")
            .then((result) => {
              this.wallet = result.data.data.wallet;
              this.factoryId += result.data.data.factoryId;
            })
            .catch(e => {
              this.errors = e.response.data.errors
            });
          return;
        }
        case "FACTORY_MEMBER": {
          axiosApi()
            .get("v2/factory/dashboard")
            .then((result) => {
              this.wallet = result.data.data.wallet;
              this.factoryId += result.data.data.factoryId;
            })
            .catch(e => {
              this.errors = e.response.data.errors
            });
          return;
        }
        case "COMPANY_MEMBER": {
          axiosApi()
            .get("v2/company/dashboard")
            .then((result) => {
              this.wallet = result.data.data.wallet;
              this.companyId += result.data.data.companyId;
              this.name = result.data.data.companyName;
            });
        }
      }
    },
    notifications(route) {
      this.notification = this.notification.filter((item) => {
        return item.route !== route;
      });
      this.notificationCount = this.notification?.length;
    },
  },
  mounted() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    this.role = localStorage.getItem("role");
    this.getRole();
  
    if (this.role !== "ADMIN" && this.role) {
      const size = document.body.clientWidth;
      if (size < 600) {
        // location.assign('https://pwa.bargram.ir/')
      }
    }

    if (localStorage.getItem("role") === "undefined") {
      sessionStorage.clear();
      localStorage.clear();
      location.replace("/");
    }
    if (this.role === "ADMIN") {
      this.permissions = JSON.parse(localStorage.getItem("permissions"));
      this.nickNameAdmin = JSON.parse(localStorage.getItem("nickname"));
      this.menu = [
        {
          href: "/",
          title: "داشبورد",
          name: "dashboard",
          icon: "icon-credit-card",
        },
        {
          href: "/manitoring",
          name: "monitoring",
          title: "پایش",
          icon: "icon-truck",
        },
         
        {
          href: "",
          title: "پایانه ها",
          name: "",
          icon: "icon-office",
          child: [
            {
              href: "/terminals",
              name: "terminals",
              title: "لیست پایانه ها",
              icon: "icon-book",
            },
            {
              href: "/terminals/newTerminal",
              name: "terminal-store",
              title: "ایجاد پایانه",
              icon: "icon-files-empty",
            },
          ],
        },
        {
          href: "",
          title: "حواله ها",
          name: "",
          icon: "icon-newspaper",
          child: [
            {
              href: "/remittance",
              name: "remittance",
              title: "لیست حواله های جاری",
              icon: "icon-book",
            },
            {
              href: "/remittanceHistory",
              name: "remittance-History",
              title: "لیست سوابق حواله ها",
              icon: "icon-book",
            },
          ],
        },
        {
          href: "",
          name: "",
          title: "شرکت ها",
          icon: "icon-companies",
          child: [
            {
              href: "/companies",
              name: "companies",
              title: "لیست شرکت ها",
              icon: "icon-book",
            },
            {
              name: "company-store",
              href: "/companies/new",
              title: "ایجاد شرکت",
              icon: "icon-file-text2",
            },
          ],
        },
        {
          href: "",
          name: "",
          title: "واحد صنفی و کاربران",
          icon: "icon-users",
          child: [
            {
              href: "/factories",
              name: "factories",
              title: "لیست واحد های صنفی",
              icon: "icon-book",
            },
            {
              href: "/realPersonFactories",
              name: "factories",
              title: "لیست کاربران حقیقی",
              icon: "icon-book",
            },
            {
              href: "/factories/new",
              name: "factory-store",
              title: "ایجاد واحد صنفی",
              icon: "icon-user-plus",
            },
          ],
        },
        {
          href: "",
          name: "",
          title: "راننده ها",
          icon: "icon-drivers",
          child: [
            {
              href: "/drivers",
              name: "drivers",
              title: "لیست راننده ها",
              icon: "icon-drivers",
            },
            {
              href: "/drivers-offline",
              name: "drivers",
              title: "راننده های افلاین",
              icon: "icon-drivers",
            },
          ],
        },
        {
          href: "",
          title: "نوبت ها",
          name: "",
          icon: "icon-user-tie",
          child: [
            {
              href: "/drivers/turns",
              name: "turns",
              title: "لیست نوبت های سامانه",
              icon: "",
            },
            {
              href: "/extendTurnsHistory",
              name: "turn-extension-history",
              title: "حذف یا تمدید",
              icon: "",
            },
          ],
        },
        {
          href: "",
          title: "استعلام ها",
          name: "",
          icon: "icon-office",
          child: [
            {
              href: "/inquiry/lastWayBill",
              name: "InquiryLastWaybill",
              title: "بارنامه ها",
              icon: "icon-book",
            },
            // {
            //   href: '/terminals',
            //   name : 'develop',
            //   title: 'اطلاعات هویتی راننده',
            //   icon: 'icon-book'
            // },
          ],
        },

        {
          href: "/smartCardRenewal",
          name: "smartCardRenewal",
          title: "تمدید کارت هوشمند",
          icon: "icon-folder-open",
        },
        {
          href: "",
          title: "اعلام بار",
          name: "",
          icon: "icon-folder-open",
          child: [
            {
              href: "/orders",
              name: "orders",
              title: "لیست اعلام بار ها",
              icon: "",
            },
            {
              href: "/orderHistory",
              name: "order-history",  
              title: "سوابق اعلام بار ها",
              icon: "",
            },
            {
              href: "/hall-announcement/list",
              name: "cars",
              title: "اعلام بار سریع",
              icon: "",
            },
            {
              href: "/hall-announcement/list/log",
              name: "cars",
              title: "سوابق اعلام بار سریع",
              icon: "",
            },
            ...(this.role === "ADMIN" ? [{
                  href: "/parsfoolad/orders",
                  name: "orders",
                  title: "اعلام بارهای فولاد",
                  icon: "",
                }] : []),
          ],
        },

        {
          href: "/tracking",
          name: "remittance-tracking-driver",
          title: "ردیابی ناوگان",
          icon: "icon-truck",
        },
        {
          href: "/carslist",
          name: "cars",
          title: "لیست ناوگان",
          icon: "icon-truck",
        },

        {
          href: "",
          name: "",
          title: "مالی",
          icon: "icon-mali",
          child: [
            {
              href: "/turnOver-sum",
              name: "turnOver-sum",
              title: "گردش مالی سیستم",
              icon: "icon-credit-card",
            },
            {
              href: "/cards",
              name: "cards",
              title: "لیست شماره کارت",
              icon: "icon-credit-card",
            },
            {
              href: "/payments",
              name: "payments",
              title: "لیست درخواست های واریز",
              icon: "icon-credit-card",
            },
            {
              href: "/receipts",
              name: "receipts",
              title: "لیست ثبت فیش",
              icon: "icon-files-empty",
            },
            {
              href: "/bankAccountList",
              name: "bankAccounts",
              title: "حساب ها",
              icon: "icon-files-empty",
            },
            {
              href: "/bankAccountListPending",
              name: "bankAccounts",
              title: "حساب های در انتظار",
              icon: "icon-files-empty",
            },
            {
              href: "/withdrawList",
              name: "withdraw-list",
              title: "برداشت ها",
              icon: "icon-files-empty",
            },
            {
              href: "/withdrawListPending",
              name: "withdraw-list",
              title: "برداشت های در انتظار",
              icon: "icon-files-empty",
            },
            {
              href: "/receiptHistory",
              name: "receipts",
              title: "لیست سوابق ثبت فیش",
              icon: "icon-book",
            },
            {
              href: "/drivers/turns-detail",
              name: "turns-Detail",
              title: "جزئیات نوبت ها",
              icon: "icon-book",
            },
          ],
        },
        {
          href: "",
          name: "",
          title: "فاصله شهر ها",
          icon: "icon-companies",
          child: [
            {
              href: "/distances?type=ADMIN",
              name: "distance-list",
              title: "ویرایش ادمین",
              icon: "icon-book",
            },
            {
              href: "/distances?type=SYSTEM",
              name: "distance-list",
              title: "ایجاد سیستم",
              icon: "icon-file-text2",
            },
          ],
        },

        {
          href: "",
          name: "",
          title: "پشتیبانی",
          icon: "icon-support",
          child: [
            {
              href: "/carbreakdown",
              name: "breakdowns",
              title: "اعلام خرابی ها",
              icon: "icon-remitance",
            },
            {
              href: "/support",
              name: "tickets",
              title: "تیکت های پشتیبانی",
              icon: "icon-remittances",
            },
            {
              href: "/support-history",
              name: "tickets",
              title: "سوابق تیکت ها",
              icon: "icon-remittances",
            },
          ],
        },
        {
          href: "",
          title: "دسترسی ها",
          name: "",
          icon: "icon-cog",
          child: [
            {
              name: "admins",
              href: "/access/admins",
              title: "لیست مدیران سیستم",
              icon: "icon-user-tie",
            },
            {
              href: "/access/roles",
              name: "roles",
              title: "لیست سطوح دسترسی",
              icon: "icon-unlocked",
            },
          ],
        },
        {
          href: "",
          title: "تنظیمات",
          name: "",
          icon: "icon-cog",
          child: [
            {
              href: "/banDriver",
              name: "banDriver",
              title: "راننده های مسدود",
              icon: "icon-cancel",
            },
            {
              href: "/updateCategory",
              name: "updateCategory",
              title: "دسته بندی محصولات",
              icon: "icon-cancel",
            },
          ],
        },
        {
          href: "/discountCode/list",
          title: "کد تخفیف",
          name: "dashboard",
          icon: "icon-credit-card",
        },
        {
          href: "/checkList/list",
          title: "چک لیست",
          name: "checkList",
          icon: "icon-playlist-check",
        },
        {
          href: "/exit",
          name: "exit",
          title: "خروج",
          icon: "icon-exit",
        },
       
      ];
      if (this.permissions?.length > 0) {
        this.permissions.push("exit");
        this.menu = this.menu.filter((item) =>
          item.name !== "" ? this.permissions.includes(item.name) : true
        );
        for (let i = 0; this.menu.length > i; i++) {
          if (this.menu[i].child) {
            this.menu[i].child = this.menu[i].child.filter((item) =>
              this.permissions.includes(item.name)
            );
          }
        }
        this.menu = this.menu.filter((item) =>
          item.child && item.child.length > 0
            ? true
            : item.name != ""
            ? true
            : false
        );
      }
    }
    if (this.role === "FACTORY" || this.role === "FACTORY_MEMBER") {
      this.permissions = JSON.parse(localStorage.getItem("permissions"));
      this.userType = localStorage.getItem("type");

      this.menu = [
        {
          items: [
            {
              href: "/",
              name: "dashboard-factory",
              text: "داشبورد",
              icon: () => import("@/assets/icons/DashboardIcon"),
            },
          ],
        },
        {
          items: [
            {
              href: "/orders/new",
              name: "orders-store",
              text: "ایجاد اعلام بار",
              icon: () => import("@/assets/icons/NewOrderIcon"),
            },
          ],
        },
        {
          items: [
            {
              href: "/remittance",
              name: "remittance-factory",
              text: "حواله های جاری",
              icon: () => import("@/assets/icons/RemittanceIcon"),
            },
          ],
        },
        ...(localStorage.getItem("customUser") ? [
        {
          items: [
            {
              href: "/remittance/parsfoolad",
              name: "remittance-parsfoolad",
              text: "حواله های فولاد",
              icon: () => import("@/assets/icons/RemittanceIcon"),
            },
          ],
        },
        // {
        //   items: [
        //     {
        //       href: "/remittance/parsfoolad/inputs",
        //       name: "remittance-parsfoolad-inputs",
        //       text: "ورودی های فولاد",
        //       icon: () => import("@/assets/icons/RemittanceIcon"),
        //     },
        //   ],
        // },
        ] : []),
       
    

        {
          title: "",
          items: [
            {
              href: "#",
              name: "",
              text: "اعلام بار ها",
              icon: () => import("@/assets/icons/OrderIcon"),
              isOpen: false,
              childItems: [
                {
                  href: "/orders",
                  name: "orders-list",
                  text: "لیست اعلام بار ها",
                },
                
                {
                  href: "/hall-announcement/list",
                  name: "hall-announcement/list",
                  text: "اعلام بار سریع",
                  icon: () => import("@/assets/icons/OrderIcon"),
                },
                {
                  href: "/hall-announcement/list/log",
                  name: "hall-announcement/list/log",
                  text: "سوابق اعلام بار سریع",
                  icon: () => import("@/assets/icons/OrderIcon"),
                },
                ...(localStorage.getItem("customUser") ? [{
                  href: "/parsfoolad/orders",
                  name: "orders",
                  text: "اعلام بارهای فولاد",
                }] : []),
              ],
            },
          ],
        },
        {
          title: "",
          items: [
            {
              href: "#",
              name: "",
              text: "مالی",
              icon: () => import("@/assets/icons/ChartIcon"),
              isOpen: false,
              childItems: [
                {
                  href: "/paymentRent",
                  name: "paymentRent",
                  text: "پرداخت کرایه",
                },
                {
                  href: "/turnOver",
                  name: "turnOver-list",
                  text: "گردش حساب",
                },
                {
                  href: "/payments",
                  name: "payment-list",
                  text: "درخواست های واریز",
                },
                {
                  href: "/receipts",
                  name: "receipt",
                  text: "سوابق ثبت فیش",
                },
                {
                  href: "/storeReceipt",
                  name: "receipt-store",
                  text: "ثبت فیش جدید",
                },
                {
                  href: "/bankAccountList",
                  name: "getAll-bankAccounts",
                  text: "حساب ها",
                },
                {
                  href: "/withdrawList",
                  name: "withdraws-all",
                  text: "برداشت",
                },
                {
                  href: "/companiesRents",
                  name: "rentCompanies",
                  text: "تقسیم بار",
                },
              ],
            },
          ],
        },

        {
          title: "",
          items: [
            {
              href: "#",
              name: "",
              text: "بارهای ورودی",
              icon: () => import("@/assets/icons/WorkDayIcon"),
              isOpen: false,
              childItems: [
                {
                  href: "/workDays",
                  name: "workDays-list",
                  text: "لیست روز کاری",
                },
                {
                  href: "/workDays/store",
                  name: "workDays-store",
                  text: "ایجاد روز کاری",
                },
                {
                  href: "/remittanceDischarge",
                  name: "remittanceDischarge",
                  text: "حواله های تخلیه",
                  icon: null,
                },
              ],
            },
          ],
        },
        // {
        //   title: "",
        //   items: [
        //     {
        //       href: "#",
        //       name: "",
        //       text: "حواله تخلیه",
        //       icon: () => import("@/assets/icons/DischargeRemittanceIcon"),
        //       isOpen: false,
        //       childItems: [
        //         {
        //           href: "/remittanceDischarge",
        //           name: "remittanceDischarge",
        //           text: "حواله های تخلیه",
        //           icon: null
        //         }
        //       ]
        //     }
        //   ]
        // },
        {
          items: [
            {
              href: "/tracking",
              name: "remittance-tracking",
              text: "ردیابی ناوگان",
              icon: () => import("@/assets/icons/TruckIcon"),
            },
          ],
        },
        {
          items: [
            {
              href: "/findRemittanceHistory",
              name: "remittanceHistory",
              text: "جست جو سوابق حواله",
              icon: () => import("@/assets/icons/RemittanceHistoryIcon"),
            },
          ],
        },
        {
          items: [
            {
              href: "/orderHistory",
              name: "orderHistory-list",
              text: "سوابق اعلام بار",
              icon: () => import("@/assets/icons/RemittanceHistoryIcon"),
            },
          ],
        },
        {
          items: [
            {
              href: "/remittanceHistory",
              name: "remittanceHistory",
              text: "سوابق حواله ها",
              icon: () => import("@/assets/icons/RemittanceHistoryIcon"),
            },
          ],
        },
        {
          title: "",
          items: [
            {
              href: "#",
              name: "users-hendell",
              text: "مدیریت کاربران",
              icon: () => import("@/assets/icons/UserIcon"),
              isOpen: false,
              childItems: [
                {
                  href: "/users",
                  name: "users",
                  text: "لیست کاربران شرکت",
                },
              ],
            },
          ],
        },
        {
          items: [
            {
              href: "/tickets",
              name: "tickets-list",
              text: "تیکت ها",
              icon: () => import("@/assets/icons/TicketsIcon"),
            },
          ],
        },
        {
          title: "",
          items: [
            {
              href: "#",
              name: "setting",
              text: "تنظیمات",
              icon: "mdi-cog-outline",
              isOpen: false,
              childItems: [
                {
                  href: "/address",
                  name: "addresses",
                  text: "آدرس ها",
                },
                {
                  href: "/banDriver",
                  name: "banDriver",
                  text: "راننده های مسدود",
                },
              ],
            },
          ],
        },
      ];

      // Accsess permission add user
      if (this.role === "FACTORY") {
        let index = this.menu.findIndex(
          (item) => item.items[0].name === "users-hendell"
        );
        this.menu[index].items[0].childItems.push({
          href: "/users/new",
          name: "users-new",
          text: "ایجاد کاربر جدید",
        });

        // if (localStorage.getItem("customUser")) { 

        //   const updatedMenu = [...this.menu];
        //   let ordersStoreIndex = this.menu.findIndex(
        //     (item) => item.items[0].name === "remittance-factory"
        //   );
        //   if (ordersStoreIndex !== -1) {
        //     const foladOrder = {
        //       href: "/remittance/parsfoolad",
        //       name: "remittance-parsfoolad",
        //       text: "حواله های فولاد",
        //       icon: () => import("@/assets/icons/RemittanceIcon"),
        //     };
            
        //     updatedMenu.splice(ordersStoreIndex + 1, 0, {
        //       items: [foladOrder]
        //     });
            
        //     this.menu = updatedMenu;
        //   }
        // }

      }
      if (this.role === "FACTORY" && this.userType === "REAL_PERSON") {
        let index = this.menu.findIndex(
          (item) => item.items[0].name === "users-hendell"
        );
        this.menu.splice(index, 1);
      }
      if (this.permissions || this.permissions?.length > 0) {
        this.menu.forEach((menuObj) => {
          if (menuObj.items[0].childItems?.length > 0) {
            return;
          } else {
            menuObj.items = menuObj.items.filter((item) =>
              this.permissions.includes(item.name)
            );
            if (menuObj.items.length === 0) {
              this.menu = this.menu.filter((item) => item !== menuObj);
            }
          }
        });
        this.menu.forEach((menuObj) => {
          if (menuObj.items[0].childItems?.length > 0) {
            menuObj.items[0].childItems = menuObj.items[0].childItems.filter(
              (child) => this.permissions.includes(child.name)
            );
            if (menuObj.items[0].childItems.length === 0) {
              this.menu = this.menu.filter((item) => item !== menuObj);
            }
          }
        });
      }
    }
    if (this.role === "COMPANY") {
      this.menu = [
        {
          items: [
            {
              href: "/",
              text: "داشبورد",
              icon: () => import("@/assets/icons/DashboardIcon"),
            },
          ],
        },

        {
          items: [
            {
              href: "/orders/new",
              text: "ایجاد اعلام بار",
              icon: () => import("@/assets/icons/NewOrderIcon"),
            },
          ],
        },
        {
          items: [
            {
              href: "/remittance",
              text: "حواله های جاری",
              icon: () => import("@/assets/icons/RemittanceIcon"),
            },
          ],
        },
        {
          title: "",
          items: [
            {
              href: "#",
              text: "اعلام بار ها",
              icon: () => import("@/assets/icons/OrderIcon"),
              isOpen: false,
              childItems: [
                {
                  href: "/orders",
                  text: "لیست اعلام بار ها",
                },
                {
                  href: "/orderHistory",
                  text: "سوابق اعلام بار",
                },
                {
                  href: "/hall-announcement/list",
                  name: "hall-announcement/list",
                  text: "اعلام بار سریع",
                  icon: () => import("@/assets/icons/OrderIcon"),
                },
                {
                  href: "/hall-announcement/list/log",
                  name: "hall-announcement/list/log",
                  text: "سوابق اعلام بار سریع",
                  icon: () => import("@/assets/icons/OrderIcon"),
                },
              ],
            },
          ],
        },
        {
          title: "",
          items: [
            {
              href: "#",
              text: "درخواست بارنامه",
              icon: () => import("@/assets/icons/NewRemittanceIcon"),
              isOpen: false,
              childItems: [
                {
                  href: "/waybills",
                  text: "لیست درخواست بارنامه",
                },
                {
                  href: "/waybillHistory",
                  text: "سوابق بارنامه ها",
                },
              ],
            },
          ],
        },
        {
          title: "",
          items: [
            {
              href: "#",
              text: "مالی",
              icon: () => import("@/assets/icons/ChartIcon"),
              isOpen: false,
              childItems: [
                {
                  href: "/paymentRent",
                  text: "پرداخت کرایه",
                },
                {
                  href: "/turnOver",
                  text: "گردش حساب",
                },
                {
                  href: "/payments",
                  text: "شارژ حساب",
                },
                {
                  href: "/receipts",
                  text: "سوابق ثبت فیش",
                },
                {
                  href: "/bankAccountList",
                  name: "card-list",
                  text: "حساب ها",
                },
                {
                  href: "/withdrawList",
                  name: "withdraw-list",
                  text: "برداشت",
                },
                {
                  href: "/storeReceipt",
                  text: "ثبت فیش جدید",
                },
                {
                  href: "/company/companiesRents",
                  name: "company-rentCompanies",
                  text: "تقسیم بار",
                },
              ],
            },
          ],
        },
        {
          title: "",
          items: [
            {
              href: "#",
              text: "سوابق حواله",
              icon: () => import("@/assets/icons/RemittanceHistoryIcon"),
              isOpen: false,
              childItems: [
                {
                  href: "/findRemittanceHistory",
                  text: "جستجوی سوابق",
                },
                {
                  href: "/remittanceHistory",
                  text: "سوابق حواله ها",
                },
              ],
            },
          ],
        },
        {
          title: "",
          items: [
            {
              href: "#",
              text: "حواله تخلیه",
              icon: () => import("@/assets/icons/DischargeRemittanceIcon"),
              isOpen: false,
              childItems: [
                {
                  href: "/remittanceDischarge",
                  text: "حواله های تخلیه",
                },
                {
                  href: "/remittanceDischarge/new",
                  text: "ایجاد حواله تخلیه",
                },
              ],
            },
          ],
        },
        {
          title: "",
          items: [
            {
              href: "#",
              text: "مدیریت کاربران",
              icon: () => import("@/assets/icons/UserIcon"),
              isOpen: false,
              childItems: [
                {
                  href: "/users/new",
                  text: "ایجاد کاربر جدید",
                },
                {
                  href: "/users",
                  text: "لیست کاربران شرکت",
                },
              ],
            },
          ],
        },
        {
          items: [
            {
              href: "/allOrders",
              text: "سالن اعلام بار",
              icon: () => import("@/assets/icons/OrderIcon"),
            },
          ],
        },
        {
          items: [
            {
              href: "/tracking",
              text: "ردیابی ناوگان",
              icon: () => import("@/assets/icons/TruckIcon"),
            },
          ],
        },
        {
          items: [
            {
              href: "/tickets",
              text: "تیکت ها",
              icon: () => import("@/assets/icons/TicketsIcon"),
            },
          ],
        },
        {
          title: "",
          items: [
            {
              href: "#",
              name: "setting",
              text: "تنظیمات",
              icon: "mdi-cog-outline",
              isOpen: false,
              childItems: [
                {
                  href: "/address",
                  name: "address",
                  text: "آدرس ها",
                },
                {
                  href: "/banDriver",
                  name: "banDriver",
                  text: "راننده های مسدود",
                },
              ],
            },
          ],
        },
        
        {
          items: [
            {
              href: "/checkList/list",
              text: "چک لیست",
              icon: () => import("@/assets/icons/TicketsIcon"),
            },
          ],
        },
      ];
    }
    if (this.role === "COMPANY_MEMBER") {
      this.menu = [
        {
          items: [
            {
              href: "/",
              text: "داشبورد",
              icon: () => import("@/assets/icons/DashboardIcon"),
            },
          ],
        },
        {
          items: [
            {
              href: "/orders/new",
              text: "ایجاد اعلام بار",
              icon: () => import("@/assets/icons/NewOrderIcon"),
            },
          ],
        },
        {
          items: [
            {
              href: "/remittance",
              text: "حواله های جاری",
              icon: () => import("@/assets/icons/RemittanceIcon"),
            },
          ],
        },
        {
          title: "",
          items: [
            {
              href: "#",
              text: "اعلام بار ها",
              icon: () => import("@/assets/icons/OrderIcon"),
              isOpen: false,
              childItems: [
                {
                  href: "/orders",
                  text: "لیست اعلام بار ها",
                },
                {
                  href: "/orderHistory",
                  text: "سوابق اعلام بار",
                },
                {
                  href: "/hall-announcement/list",
                  name: "hall-announcement/list",
                  text: "اعلام بار سریع",
                  icon: () => import("@/assets/icons/OrderIcon"),
                },
                {
                  href: "/hall-announcement/list/log",
                  name: "hall-announcement/list/log",
                  text: "سوابق اعلام بار سریع",
                  icon: () => import("@/assets/icons/OrderIcon"),
                },
              ],
            },
          ],
        },
        {
          title: "",
          items: [
            {
              href: "#",
              text: "درخواست بارنامه",
              icon: () => import("@/assets/icons/NewRemittanceIcon"),
              isOpen: false,
              childItems: [
                {
                  href: "/waybills",
                  text: "لیست درخواست بارنامه",
                },
                {
                  href: "/waybillHistory",
                  text: "سوابق بارنامه ها",
                },
              ],
            },
          ],
        },
        {
          title: "",
          items: [
            {
              href: "#",
              text: "مالی",
              icon: () => import("@/assets/icons/ChartIcon"),
              isOpen: false,
              childItems: [
                {
                  href: "/paymentRent",
                  text: "پرداخت کرایه",
                },
                {
                  href: "/turnOver",
                  text: "گردش حساب",
                },
                {
                  href: "/payments",
                  text: "شارژ حساب",
                },
                {
                  href: "/receipts",
                  text: "سوابق ثبت فیش",
                },
                {
                  href: "/bankAccountList",
                  name: "card-list",
                  text: "حساب ها",
                },
                {
                  href: "/withdrawList",
                  name: "withdraw-list",
                  text: "برداشت",
                },
                {
                  href: "/storeReceipt",
                  text: "ثبت فیش جدید",
                },
              ],
            },
          ],
        },
        {
          title: "",
          items: [
            {
              href: "#",
              text: "سوابق حواله",
              icon: () => import("@/assets/icons/RemittanceHistoryIcon"),
              isOpen: false,
              childItems: [
                {
                  href: "/findRemittanceHistory",
                  text: "جستجوی سوابق",
                },
                {
                  href: "/remittanceHistory",
                  text: "سوابق حواله ها",
                },
              ],
            },
          ],
        },
        {
          title: "",
          items: [
            {
              href: "#",
              text: "حواله تخلیه",
              icon: () => import("@/assets/icons/DischargeRemittanceIcon"),
              isOpen: false,
              childItems: [
                {
                  href: "/remittanceDischarge",
                  text: "حواله های تخلیه",
                },
                {
                  href: "/remittanceDischarge/new",
                  text: "ایجاد حواله تخلیه",
                },
              ],
            },
          ],
        },

        {
          items: [
            {
              href: "/allOrders",
              text: "سالن اعلام بار",
              icon: () => import("@/assets/icons/OrderIcon"),
            },
          ],
        },
        {
          items: [
            {
              href: "/tracking",
              text: "ردیابی ناوگان",
              icon: () => import("@/assets/icons/TruckIcon"),
            },
          ],
        },
        {
          items: [
            {
              href: "/tickets",
              text: "تیکت ها",
              icon: () => import("@/assets/icons/TicketsIcon"),
            },
          ],
        },
        {
          title: "",
          items: [
            {
              href: "#",
              name: "setting",
              text: "تنظیمات",
              icon: "mdi-cog-outline",
              isOpen: false,
              childItems: [
                {
                  href: "/address",
                  name: "address",
                  text: "آدرس ها",
                },
                {
                  href: "/banDriver",
                  name: "banDriver",
                  text: "راننده های مسدود",
                },
              ],
            },
          ],
        },
      ];
    }
  },
  beforeMount() {
    this.getNow();
    setInterval(this.getNow, 1000);
  },
  watch: {
    factoryId() {
      window.Echo.channel(this.factoryId).listen(
        ".App\\Events\\Factory",
        (e) => {
          if (e.message) {
            this.notification.push({ message: e.message, route: e.route });
            this.notificationCount += 1;
          }
          if (e.wallet) {
            this.wallet = e.wallet;
          }
        }
      );
    },
    companyId() {
      window.Echo.channel(this.companyId).listen(
        ".App\\Events\\Company",
        (e) => {
          if (e.message) {
            this.notification.push({ message: e.message, route: e.route });
            this.notificationCount += 1;
          }
          if (e.wallet) {
            this.wallet = e.wallet;
          }
        }
      );
    },
  },
  computed: {
    layout() {
      const layout = this.$route.meta.layout || defaultLayout;
      return () => import(`@/layouts/${layout}.vue`);
    },
  },
};
</script>
